// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "68b2a926c1b4d3ca04e3" + "/css/" + chunkId + ".css";
};